export default "__VITE_ASSET__DMyvbKwb__"